module.exports = __webpack_public_path__ + "img/icon_small_tactical_map.9d87fc7d.png";